// extracted by mini-css-extract-plugin
module.exports = {"paymentMethod":"OrderPaymentMethod_paymentMethod__J_MDz","paymentMethodImg":"OrderPaymentMethod_paymentMethodImg__Y2672"};